import IbanForm from "./IbanForm.view";

export default IbanForm;
